<template>
	<div>

        <el-card shadow="never">
            <el-row class="app-btn-group" :gutter="10">
                <el-col :span="4" offset="8">
                    <el-select
                    :placeholder="$t('submit_time')"
                    size="medium" 
                    clearable style="width: 100%" 
                    v-model="searchTime">
                        <el-option
                            v-for="s in timeList"
                            :key="s.time"
                            :label="s.label"
                            :value="s.time">
                        </el-option>
                    </el-select>
                 </el-col>
                <el-col :span="4">
                    <el-select
                    :placeholder="$t('command_status')"
                    size="medium" 
                    clearable 
                    style="width: 100%" 
                    v-model="searchStatus">
                        <el-option
                            v-for="s in statusList"
                            :key="s.status"
                            :label="s.label"
                            :value="s.status">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <el-input @keyup.enter.native="searchHandler" v-model="searchInput" size="medium" :placeholder="$t('please_input_keyword_id_or_name')">
                        <el-button @click="searchHandler" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
            </el-row>



            <el-table class="app-table"  size="medium"  v-loading="tableLoading" :data="tableData">
            
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="name" :label="$t('name')"></el-table-column>

                <el-table-column prop="space_name" :label="$t('space_name')" >
                    <template slot-scope="scope">
                    {{ scope.row.space_name }}
                        <el-tooltip effect="dark" :content="$t('belong_to_space') + ': ' + scope.row.space_name" placement="top">
                            <span class="app-cursor"><i class="iconfont icon-space"></i></span>
                        </el-tooltip>
                        
                    </template>
                </el-table-column>

                <el-table-column prop="works" :label="$t('works')">
                    <template slot-scope="scope">
                        
                    <el-popover
                      placement="right"
                      width="600"
                      trigger="click">
                      <el-table :data="gridData" size="small"
                      :default-sort = "{prop: 'ctime', order: 'ascending'}">

                        <el-table-column width="50" property="id" label="ID"></el-table-column>
                        <el-table-column width="150" property="name" label="名称"></el-table-column>
                        <el-table-column property="template" label="模板名"></el-table-column>
                        <el-table-column width="70" property="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == $root.ApplyStatusNone"><i class="iconfont small left icon-wait"></i>{{ $t('wait_online') }}</span>
                                <span v-else-if="scope.row.status == $root.ApplyStatusIng"><i class="iconfont small left icon-coffee"></i>{{ $t('onlineing') }}</span>
                                <span class="app-color-success" v-else-if="scope.row.status == $root.ApplyStatusSuccess"><i class="iconfont small left icon-success"></i>{{ $t('success') }}</span>
                                <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusFailed"><i class="iconfont small left icon-failed"></i>{{ $t('failed') }}</span>
                                <span class="app-color-gray" v-else-if="scope.row.status == $root.ApplyStatusDrop"><i class="iconfont small left icon-drop"></i>{{ $t('drop') }}</span>
                                <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusRollback"><i class="iconfont small left icon-rollback"></i>{{ $t('rollback') }}</span>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ctime" width="100" :label="$t('submit_time')" sortable>
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" :content="$root.FormatDateTime(scope.row.ctime)" placement="top">
                                    <span class="app-cursor">{{ $root.FormatDateFromNow(scope.row.ctime) }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                      </el-table>

                      <el-button @click="loadWorksTable(scope.row.id, 'cmd')" slot="reference" size="mini" :type="scope.row.status == $root.ApplyStatusFailed?'danger':'primary'" plain>命令({{scope.row.works[0]}})&nbsp;部署({{scope.row.works[1]}})</el-button>
                    
                    </el-popover>
                    
                    </template>

                </el-table-column>
                
                <el-table-column prop="submit_time" width="150" :label="$t('submit_time')">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="$root.FormatDateTime(scope.row.ctime)" placement="top">
                            <span class="app-cursor">{{ $root.FormatDateFromNow(scope.row.ctime) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>

                
                <el-table-column prop="status" width="150" :label="$t('status')">
                    <template slot-scope="scope">
                        
                        <span v-if="scope.row.status == $root.ApplyStatusIng"><i class="iconfont small left icon-coffee"></i>{{ $t('ongoing') }}</span>

                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusFailed"><i class="iconfont small left icon-failed"></i>{{ $t('failed') }}</span>
                        
                        <span class="app-color-success" v-else-if="scope.row.status == $root.ApplyStatusSuccess"><i class="iconfont small left icon-success"></i>{{ $t('finished') }}</span>
                       
                        <span class="app-color-gray" v-else-if="scope.row.status == $root.ApplyStatusDrop"><i class="iconfont small left icon-drop"></i>{{ $t('drop') }}</span>

                        <span v-else>--</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('operate')" width="150" align="right">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" @command="workflowHandler($event, scope.row)">
                            <el-button size="small">
                                {{ $t('operate') }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu class="app-op-dropdown" slot="dropdown">
                                <el-dropdown-item command="view" v-if="$root.CheckPriv($root.Priv.WORKFLOW_VIEW)">
                                    <i class="iconfont left small icon-view"></i>{{ $t('view') }}
                                </el-dropdown-item>
                                <el-dropdown-item command="edit" 
                                v-if="$root.CheckPriv($root.Priv.WORKFLOW_EDIT)&&scope.row.status != $root.ApplyStatusDrop">
                                    <i class="iconfont left small icon-edit"></i>{{ $t('edit') }}
                                </el-dropdown-item>
                                
                                <el-dropdown-item command="drop"
                                v-if="scope.row.works[0]==0 && scope.row.works[1]==0 && $root.CheckPriv($root.Priv.WORKFLOW_DROP) &&scope.row.status != $root.ApplyStatusDrop">
                                    <i class="iconfont left small icon-drop"></i>{{ $t('drop') }}
                                </el-dropdown-item>

                                <el-dropdown-item command="execute"
                                v-if="$root.CheckPriv($root.Priv.WORKFLOW_VIEW)&&scope.row.status != $root.ApplyStatusDrop">
                                    <i class="iconfont left small icon-audit"></i>{{ $t('openflow') }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                class="app-pagination"
                @current-change="currentChangeHandler"
                :current-page.sync="$root.Page"
                :page-size="$root.PageSize"
                :total="$root.Total">
            </el-pagination>
        </el-card>

        <!-- 查看模态框 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        @close="closeDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form size="medium" label-width="120px">
                    <el-form-item :label="$t('space_name')">
                        {{ dialogDetail.space_name }}
                    </el-form-item>
                    
                    <el-form-item :label="$t('name')">
                        {{ dialogDetail.name }}
                    </el-form-item>
                    
                    <el-form-item :label="$t('command_illustrate')">
                        {{ dialogDetail.description }}
                    </el-form-item>
                    
                    <el-form-item :label="$t('submit_time')">
                        {{ this.$root.FormatDateTime(dialogDetail.ctime) }}
                    </el-form-item>
                    <el-form-item :label="$t('status')">
                        <span v-if="dialogDetail.status == 2 ">{{$t('ongoing')}}</span>
                        <span v-else-if="dialogDetail.status == 3">{{$t('ongoing')}}</span>
                        <span v-else> -- </span>
                    </el-form-item>

                </el-form>
            </div>
        </el-dialog>

        <!-- 编辑模态框 -->
        <el-dialog  
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogEditVisible"
        @close="closeEditDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form 
                class="app-form" 
                ref="dialogRef" 
                :model="dialogForm" 
                size="medium" 
                label-width="130px">
                    
                    <el-form-item 
                    :label="$t('name')">
                        {{ dialogForm.name}}
                    </el-form-item>

                    <el-form-item 
                    :label="$t('command_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('command_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_command_illustrate')" v-model="dialogForm.description" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeEditDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="dialogBtnLoading" size="small" type="primary" @click="dialogSubmitEditHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>

       
            </div>
        </el-dialog>


	</div>
</template>

<script>
import {
WorkflowSubmitApi,
WorkflowDetailApi,
WorkflowUpdateApi,
WorkflowListApi,
WorkflowDeleteApi,
WorksListByFlowid,
WorkflowDropApi,
 } from '@/api/workflow.js'

import {
    detailSpaceApi,
    listSpaceApi,
} from '@/api/project.js'

import {
    TemplateAllApi,
    OperateDetailApi,
    OperateListApi,
} from '@/api/command.js'
export default {
    data() {
        return {
            dialogVisible: false,
            dialogEditVisible: false,
            dialogTitle: '',
            dialogSpaceVisible: false,
            searchInput: '',
            spaceList: [],
            clusterList: [],
            tableLoading: false,
            tableData: [],
            spaceId: undefined,
            searchAuditStatus: '',
            searchStatus:'',
            searchTemplateId:'',
            templateList: [],
            searchTime: '',
            auditStatus: 2,
            auditRefusalReason: '',
            dialogForm: {
                id: 0,
                name: '',
                description: '',
                tmode: 1,
                template_name:'',
                status: 0,
            },
            
            dialogDetail:{
                name: '',
                space_name: '',
                tmode: 1,
                template_name: '',
                flow_name: '',
                username: '',
                audit_status: 0,
                description: '',
                ctime: '',
                cmd: '',
                status: 1,
            },
            gridData: [],
            gridDataStatus: 0,
            timeList: [
                {time: 1, label: this.$t('today')},
                {time: 7, label: this.$t('7day')},
                {time: 30, label: this.$t('within_one_month')},
                {time: 90, label: this.$t('within_three_months')},
                {time: 365, label: this.$t('within_a_year')},
                {time: 0, label: this.$t('any_time')},
            ],
            statusList: [
                {status: this.$root.ApplyStatusIng, label: this.$t('ongoing')},
                {status: this.$root.ApplyStatusSuccess, label: this.$t('finished')},
                {status: this.$root.ApplyStatusDrop, label: this.$t('drop')},
            ],
           

            spaceDetail: {},
        }
    },

    methods: {
        loadTableData() {
            this.tableLoading = true
            let query = {
                keyword : this.searchInput,
                time: this.searchTime,
                status: this.searchStatus,
                offset: this.$root.PageOffset(),
                limit: this.$root.PageSize,
            }
            WorkflowListApi(query).then(res => {
                this.tableData = res.list
                this.$root.Total = res.total
                this.tableLoading = false
            }).catch(err => {
                this.tableLoading = false
            })
        },

       

        loadWorksTable(flowid){
            WorksListByFlowid({flowid: flowid}).then(res=>{
                this.gridData = res.list
                this.gridDataStatus = res.err_status
            }).catch(err=>{
                this.gridData = []
            })
        },

        workflowHandler(cmd, row) {
            switch(cmd) {
                case 'view':
                    this.viewHandler(cmd, row)
                    break
                case 'edit':
                    this.editHandler(cmd, row)
                    break
                case 'audit':
                    this.auditHandler(cmd, row)
                    break
                case 'drop':
                    this.dropHandler(cmd, row)
                    break
                case 'execute':
                    this.executeHandler(cmd, row)
                    break
            }
        },

        viewHandler(cmd, row) {
            this.dialogLoading = true
            WorkflowDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogDetail = detail
                this.openDialogHandler(cmd == 'view' ? this.$t('view') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })
        },
        editHandler(cmd, row){
            this.dialogLoading = true
            WorkflowDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogDetail = detail
                this.dialogForm = {
                    id: row.id,
                    name: detail.name,
                    description:  detail.description,
                }
                this.openEditDialogHandler(cmd == 'edit' ? this.$t('edit') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })  
        },
        auditHandler(cmd, row){
            this.dialogLoading = true
            OperateDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogDetail = detail
                this.dialogDetail.cmd = cmd
                this.dialogForm = {
                    id: row.id,
                }
                this.openDialogHandler(cmd == 'view' ? this.$t('view') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })
        },
        dropHandler(cmd, row) {
            this.$root.ConfirmDelete(() => {
                WorkflowDropApi({id: row.id}).then(res => {
                    this.loadTableData()
                })
            }, this.$t('drop_deploy_apply_tips'))
        },
        executeHandler(cmd, row) {
            this.$router.push({name: 'workflowDetail', query: { id: row.id}})
        },
        openDialogHandler(title) {
            this.dialogTitle = title
            this.dialogVisible = true
        },
        openEditDialogHandler(title){
            this.dialogTitle = title
            this.dialogEditVisible = true
        },
        closeDialogHandler(){
            this.dialogVisible = false
        },
        closeEditDialogHandler(){
            this.dialogEditVisible = false
            this.dialogForm = {}
            this.dialogLoading = false
        },

        dialogSubmitEditHandler() {
            this.$refs.dialogRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.btnLoading = true
                let postData = {
                    id: this.dialogForm.id,
                    description: this.dialogForm.description,
                }
                WorkflowUpdateApi(postData).then(res => {
                    this.$alert(this.$t('update_success'), this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeEditDialogHandler()
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
            })
        },
        dialogSubmitAuditStatusHandler(){

            this.btnLoading = true
            let postData = {
                id: this.dialogForm.id,
                audit_status: this.auditStatus,
                audit_refusal_reason: this.auditRefusalReason,
            }
            OperateAuditStatusUpdateApi(postData).then(res => {
                this.$alert(this.$t('command_apply_submit_success'), this.$t('submit_success'), {
                    type: 'success',
                    confirmButtonText: this.$t('enter'),
                    callback: action => {
                        this.closeDialogHandler()
                        this.loadTableData()
                    }
                })
                this.btnLoading = false
            }).catch(err => {
                this.btnLoading = false
            })  
        },

/*
        auditStatusTitle(auditStatus) {
            let auditTitle = ''
            this.auditStatusList.forEach(item => {
                if (auditStatus == item.status) {
                    auditTitle = item.label
                }
            })
            return auditTitle
        },
*/

        dialogCloseHandler() {
            this.dialogVisible = false
            this.dialogLoading = false
            this.btnLoading = false
            this.$refs.dialogRef.resetFields();
            this.dialogForm = {}
        },
        currentChangeHandler() {
            this.loadTableData()
        },

        loadTemplateAll() {
            TemplateAllApi().then(res => {
                if (res && res.length > 0 ) {
                    this.templateList = res
                }
            })
        },
        searchHandler() {
            this.$root.PageInit()
            this.loadTableData()
        },

    },

    mounted() {
        this.$root.PageInit()
        this.loadTemplateAll()
        this.loadTableData()
    }

}
</script>
